const WishlistActionTypes = {
  ADD_TO_WISHLIST: "Wishlist/ADD_TO_WISHLIST",
  UPDATE_WISHLIST: "Wishlist/UPDATE_WISHLIST",
  DELETE_FROM_WISHLIST: "Wishlist/DELETE_FROM_WISHLIST",
  DELETE_ALL_FROM_WISHLIST: "Wishlist/DELETE_ALL_FROM_WISHLIST",
};

export default WishlistActionTypes;
